import { AlertService } from '../../alert.service';
import { UserService } from '../../services/user.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
 
 
@Component({
    moduleId: module.id,
    templateUrl: 'register.component.html'
})
 
export class RegisterComponent {
    model: any = {};
    loading = false;
 
    constructor(
        private router: Router,
        private userService: UserService,
        private alertService: AlertService) { }
 
    register() {
        this.loading = true;
        this.userService.create(this.model)
            .subscribe(
                data => {
                    this.alertService.success('Registration successful', true);
                    this.router.navigate(['/login']);
                },
                error => {
                    this.alertService.error(error._body);
                    this.loading = false;
                });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/register/register.component.ts